import React from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import { Container, IconButton } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Fade from '@material-ui/core/Fade';
export function RowMenu({ data, handleRoleChange }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <>
      <>
        <IconButton
          // color="secondary"
          id={`fade-button-${data.vonageParticipantId
          }`}
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <MoreVertIcon variant='contained' color='primary' />
        </IconButton>

        <Menu
          id='fade-menu'
          MenuListProps={{
            'aria-labelledby': 'fade-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem onClick={() => handleRoleChange(data.vonageParticipantId
, 'Speaker',data.userId)}>
            Speaker
          </MenuItem>
          <MenuItem onClick={() => handleRoleChange(data.vonageParticipantId
, 'Viewer',data.userId)}>
            Viewer
          </MenuItem>
        </Menu>
      </>
    </>
  );
}
